import styled from 'styled-components';

export const Label = styled.label`
  font-size: 16px;
  font-weight: 500;
`;
